import Vue from 'vue'
import Pagination from './Pagination'

Vue.component('FpPagination', Pagination)
